import { AxiosResponse } from 'axios';
import { api, fetchAllPages } from 'src/common/utils';

import { PaginatedResponse, WLDevice } from './types';

const WL_DEVICES_URL = '/waiting_lists_v2/comet/devices';

export const fetchWLDevices = (): Promise<AxiosResponse<PaginatedResponse<WLDevice>>> =>
  fetchAllPages<WLDevice>(WL_DEVICES_URL);

export const updateDeviceNickname = (
  deviceId: number,
  nickname: string
): Promise<AxiosResponse<{ nickname: string }>> =>
  api.patch(`/waiting_lists_v2/comet/devices/${deviceId}/nickname`, { nickname });

export const refreshTV = (): Promise<AxiosResponse> =>
  api.post('/waiting_lists_v2/waiting_lists/refresh_tv');
